import React from 'react';
import { PaymentMethod } from 'types/paymentMethod';
import PaymentMethodItemModule from './PaymentMethodItemModule';
import List from 'components/list/List';

type PaymentMethodListModuleProps = {
  paymentMethods: PaymentMethod[];
  handleSearch: () => void;
};

const PaymentMethodListModule: React.FC<PaymentMethodListModuleProps> = ({ paymentMethods, handleSearch }) => {
  return (
    <List>
      {paymentMethods.map(paymentMethod => (
        <PaymentMethodItemModule handleSearch={handleSearch} key={paymentMethod.id} paymentMethod={paymentMethod} />
      ))}
    </List>
  );
};

export default PaymentMethodListModule;
